export const validateRegister = (email, password, confirmPassword) => {
  const errors = {};

  if (!email) errors.email = "Email is required";
  else if (!/\S+@\S+\.\S+/.test(email))
    errors.email = "Invalid email format";

  if (!password) errors.password = "Password is required";
  else if (password.length < 6)
    errors.password = "Password must be at least 6 characters";

  if (!confirmPassword)
    errors.confirmPassword = "Please confirm password";
  else if (confirmPassword !== password)
    errors.confirmPassword = "Passwords do not match";

  return errors;
};
